var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "search-underlay", on: { click: _vm.unFocus } }),
    _c("div", { staticClass: "byor-single-search-wrapper" }, [
      _c(
        "div",
        {
          staticClass: "search-underlay-close-note",
          on: { click: _vm.unFocus },
        },
        [
          _vm._v(" close search "),
          _c("b-icon", { attrs: { icon: "x-circle-fill" } }),
        ],
        1
      ),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.singleSearchParam,
            expression: "singleSearchParam",
          },
        ],
        staticClass: "form-control byor-single-search",
        attrs: {
          type: "text",
          id: "byor_single_search",
          placeholder: _vm.placeholder,
          autocomplete: "off",
        },
        domProps: { value: _vm.singleSearchParam },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.onSearch.apply(null, arguments)
          },
          focus: _vm.onFocus,
          input: function ($event) {
            if ($event.target.composing) return
            _vm.singleSearchParam = $event.target.value
          },
        },
      }),
      !!_vm.singleSearchParam
        ? _c(
            "span",
            {
              staticClass: "btn btn-default reset-search",
              on: { click: _vm.resetSearch },
            },
            [
              _vm._v(" Clear search "),
              _c("b-icon", { attrs: { icon: "x-circle-fill" } }),
            ],
            1
          )
        : _c(
            "span",
            {
              staticClass: "btn btn-default reset-search",
              class: { active: _vm.displayExamples },
              on: { click: _vm.toggleExamples },
            },
            [_vm._v(" Examples ")]
          ),
      !!_vm.singleSearchConfig
        ? _c("div", { staticClass: "byor-single-search-results-wrapper" }, [
            _vm.visibleCategories.length > 0 ||
            _vm.showFreeTextPending ||
            _vm.isFreeTextQuery ||
            _vm.displayExamples
              ? _c(
                  "div",
                  {
                    staticClass: "byor-single-search-results-groups",
                    attrs: { id: "byor_single_search_results" },
                  },
                  [
                    _vm.displayExamples
                      ? _c(
                          "div",
                          { staticClass: "ss-examples" },
                          [
                            _c("strong", { staticClass: "ss-examples-title" }, [
                              _vm._v(
                                "Find multi-omic Common Fund data, analyses, and program knowledge."
                              ),
                            ]),
                            _vm._l(_vm.exampleGroups, function (group) {
                              return _c(
                                "div",
                                {
                                  key: group.id,
                                  staticClass: "ss-example-group",
                                },
                                [
                                  _c("strong", [_vm._v(_vm._s(group.lead))]),
                                  _c(
                                    "div",
                                    { staticClass: "ss-example-list" },
                                    _vm._l(group.examples, function (example) {
                                      return _c(
                                        "div",
                                        {
                                          key: example,
                                          staticClass: "ss-example",
                                          on: {
                                            click: function ($event) {
                                              return _vm.useExample(example)
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(example) + " ")]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.showSearchSteps
                      ? _c("div", { staticClass: "ss-search-steps" }, [
                          _c("div", { staticClass: "ss-search-steps-guide" }, [
                            _c("div", { staticClass: "ss-step-entity" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "ss-step",
                                  class: { selected: _vm.isEntityStepSelected },
                                },
                                [
                                  _c("span", { staticClass: "ss-step-num" }, [
                                    _vm._v("1"),
                                  ]),
                                  _vm._v(" Select an entity "),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "ss-step-action" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "ss-step",
                                  class: { selected: _vm.isActionStepSelected },
                                },
                                [
                                  _c("span", { staticClass: "ss-step-num" }, [
                                    _vm._v("2"),
                                  ]),
                                  _vm._v(" Choose an action "),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._l(_vm.visibleCategories, function (cat) {
                      return _c(
                        "div",
                        {
                          key: cat.id,
                          staticClass: "ss-category",
                          class: {
                            "is-step-two": !!_vm.lockedCategoryId,
                            "is-free-text": cat.isFreeText,
                          },
                        },
                        [
                          !cat.isFreeText
                            ? _c("div", { staticClass: "ss-category-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "ss-category-title" },
                                  [_vm._v(_vm._s(cat.label))]
                                ),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "ss-category-body" }, [
                            !cat.isFreeText
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "ss-entities",
                                    class: { locked: _vm.isEntityLocked(cat) },
                                  },
                                  _vm._l(
                                    _vm.categoryEntities(cat),
                                    function (entity) {
                                      return _c(
                                        "div",
                                        {
                                          key: cat.id + "-" + entity.value,
                                          staticClass: "ss-entity",
                                          class: {
                                            selected:
                                              _vm.isEntitySelected(entity),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectEntity(
                                                cat,
                                                entity
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(entity.label) + " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                            _vm.categoryQuestions(cat).length
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "ss-questions",
                                    class: {
                                      locked: _vm.isQuestionLocked(cat),
                                    },
                                  },
                                  _vm._l(
                                    _vm.categoryQuestions(cat),
                                    function (question, qIndex) {
                                      return _c(
                                        "div",
                                        {
                                          key: cat.id + "-q-" + qIndex,
                                          staticClass: "ss-question",
                                          class: {
                                            selected:
                                              _vm.isQuestionSelected(question),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectQuestion(
                                                cat,
                                                question
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(question["url label"]) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }),
                    _vm.showSearchSteps
                      ? _c(
                          "div",
                          {
                            staticClass: "ss-guide-actions",
                            class: { "is-free-text": _vm.isFreeTextFallback },
                          },
                          _vm._l(_vm.guideActions, function (action) {
                            return _c(
                              "div",
                              {
                                key: "row-" + action.id,
                                staticClass: "ss-guide-bubble",
                                class: {
                                  selected: _vm.isQuestionSelected(action),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectGuideAction(action)
                                  },
                                },
                              },
                              [
                                _vm._v(" " + _vm._s(action["url label"]) + " "),
                                _c(
                                  "span",
                                  { staticClass: "ss-step-num ss-ai-icon" },
                                  [_vm._v("AI")]
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm.showFreeTextPending &&
                    _vm.visibleCategories.length === 0
                      ? _c("div", { staticClass: "ss-llm-loading" }, [
                          _c("div", { staticClass: "loading" }),
                          _c("span", [_vm._v("Searching…")]),
                        ])
                      : _vm._e(),
                    _vm.llmPath
                      ? _c(
                          "div",
                          { staticClass: "ss-llm-panel" },
                          [
                            _vm.isLoading
                              ? _c("div", { staticClass: "ss-llm-loading" }, [
                                  _c("div", { staticClass: "loading" }),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.llmPath === "llm-discovery"
                                          ? "Preparing your question…"
                                          : "Finding CFDE programs…"
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm.llmResults
                              ? [
                                  _vm.llmPath === "llm-programs"
                                    ? _c(
                                        "div",
                                        { staticClass: "ss-llm-box" },
                                        [
                                          _c("strong", [
                                            _vm._v("Suggested CFDE Programs:"),
                                          ]),
                                          _vm._l(
                                            _vm.llmResults.programs || [],
                                            function (program, pIndex) {
                                              return _c(
                                                "div",
                                                {
                                                  key:
                                                    "prog-" +
                                                    pIndex +
                                                    "-" +
                                                    program.id,
                                                  staticClass: "ss-llm-program",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ss-llm-program-head",
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(program.name)
                                                        ),
                                                      ]),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ss-llm-program-links",
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                href: _vm.kcURL(
                                                                  "/r/kc_programs?DCC=" +
                                                                    program.id
                                                                ),
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "program snapshot"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm.programLinks[
                                                            program.id
                                                          ]
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: _vm
                                                                      .programLinks[
                                                                      program.id
                                                                    ],
                                                                    target:
                                                                      "_blank",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "data portal"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(program.reason)
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          !(
                                            _vm.llmResults.programs &&
                                            _vm.llmResults.programs.length
                                          )
                                            ? _c("div", [
                                                _vm._v(
                                                  " No programs suggested. "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    : _vm.llmPath === "llm-discovery"
                                    ? _c(
                                        "div",
                                        { staticClass: "ss-llm-box" },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              "Knowledge Center Discovery:"
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              "See evidence-backed hypotheses about the biology behind your research interest:"
                                            ),
                                          ]),
                                          _vm.discoveryQuestions.length
                                            ? _vm._l(
                                                _vm.discoveryQuestions,
                                                function (query, qIndex) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: "disc-" + qIndex,
                                                      staticClass:
                                                        "ss-llm-discovery-choice",
                                                      class: {
                                                        selected:
                                                          _vm.selectedDiscoveryQuery ===
                                                          query,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.selectDiscoveryQuery(
                                                            query
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ss-llm-discovery-query",
                                                        },
                                                        [_vm._v(_vm._s(query))]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "ss-llm-discovery-query",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.activeDiscoveryQuery
                                                    )
                                                  ),
                                                ]
                                              ),
                                          _c("div", [
                                            _vm._v(
                                              " Using pre-computed genetic associations between 6,000 common & rare disease phenotypes and 150,000 gene expression signatures from various CFDE Programs. "
                                            ),
                                          ]),
                                          _vm.activeDiscoveryQuery
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "ss-llm-discovery-link",
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: _vm.kcURL(
                                                          "/r/factor_base_reveal?query=" +
                                                            encodeURIComponent(
                                                              _vm.activeDiscoveryQuery
                                                            )
                                                        ),
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mechanism discovery"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }